export default "__VITE_ASSET__bfb2b423__"